import { useMediaQuery, useTheme } from '@mui/material';

/**
 * The F-series mobile pivot (Phase F1, D-52): true below `md` (768), read from
 * the theme's breakpoint map, which is the SCSS `$breakpoints` map through the
 * `:export` bridge (rules/responsive.md), never a pixel literal.
 *
 * Behaviour only -- a component that must render a different subtree below
 * md (card list, temporary drawer, full-screen modal). Layout stays in SCSS
 * media queries. `useTheme()` carries MUI's default theme where no provider is
 * mounted (unit tests), and `useMediaQuery` is false where `matchMedia` is
 * missing (jsdom); `noSsr` makes the first client render the real answer.
 */
export const useIsBelowMd = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
};
